import React, { PropsWithChildren } from 'react';

import { ResponseError } from './pokCore/autogenerated/pokApiClient';

export interface NotificationsProviderType {
  onPromise: (
    promise: Promise<void>,
    action?: () => void,
    actionIfFailed?: () => void,
  ) => Promise<void>;
  saveCompleted: () => void;
  unauthorized: () => void;
  caughtError: (errorResponse: ResponseError) => void;
  badLink: (reason?: string, redirectLocation?: string) => void;
  conflict: (text: React.ReactNode) => void;
  error: (text: React.ReactNode) => void;
  online: () => void;
  offline: () => void;
  accessForbidden: () => void;
}

const emptyHandler = async () => {
  // implemented elsewhere
};

const emptyState = {
  onPromise: emptyHandler,
  saveCompleted: emptyHandler,
  unauthorized: emptyHandler,
  caughtError: emptyHandler,
  badLink: emptyHandler,
  conflict: emptyHandler,
  error: emptyHandler,
  online: emptyHandler,
  offline: emptyHandler,
  accessForbidden: emptyHandler,
};

export const NotificationsContext =
  React.createContext<NotificationsProviderType>(emptyState);

export const NotificationsProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <NotificationsContext.Provider value={emptyState}>
      {children}
    </NotificationsContext.Provider>
  );
};
